module.exports = "<ol class=\"breadcrumb\">\n    <!--<li>-->\n        <!--<a [routerLink]=\"'/'\">Home</a>-->\n    <!--</li>-->\n    <!--<li>-->\n        <!--<a [routerLink]=\"['/data-entry']\">Data Entry</a>-->\n    <!--</li>-->\n    <!--<li>-->\n        <!--Client-->\n    <!--</li>-->\n\n    <li *ngFor=\"let breadcrumb of breadcrumbs;\">\n        <a [routerLink]=\"'/'\">{{breadcrumb}}</a>\n    </li>\n\n</ol>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/common/breadcrumbs/breadcrumbs.template.html
// module id = 1389
// module chunks = 9